<template>
  <v-container fluid>
    <v-row justify="space-between" no-gutters align="center">
      <v-col cols="12" md="5">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1">Oportunidades fechadas</div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <totalizador-fechado></totalizador-fechado>
    <v-tabs
      next-icon="chevron_right"
      prev-icon="chevron_left"
      show-arrows
      class="ui-tabs"
      v-model="tabs">
      <v-tab link to="#oportunidades">
        <v-icon>handshake</v-icon> Oportunidades
      </v-tab>
      <v-tab link to="#kanban-fotovoltaico" v-if="$root.Permissions.integrator()">
        <v-icon>view_kanban</v-icon> Kanban fotovoltaico
      </v-tab>
      <v-tab link to="#funil-fotovoltaico" v-if="$root.Permissions.integrator()">
        <v-icon>filter_alt</v-icon> Funil fotovoltaico
      </v-tab>
      <v-tab link to="#relatorios">
        <v-icon>assessment</v-icon> Relatórios
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item class="px-1 pb-1" id="oportunidades">
        <lista-oportunidades :status="3"></lista-oportunidades>
      </v-tab-item>
      <v-tab-item class="px-1 pb-1" id="kanban-fotovoltaico">
        <kanban-oportunidades :status="3"></kanban-oportunidades>
      </v-tab-item>
      <v-tab-item class="px-1 pb-1" id="funil-fotovoltaico">
        <funil-oportunidades :status="3"></funil-oportunidades>
      </v-tab-item>
      <v-tab-item class="px-1 pb-1" id="relatorios">
        <relatorio-oportunidades :status="3"></relatorio-oportunidades>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import TotalizadorFechado from './TotalizadorFechado.vue'
import ListaOportunidades from '../ListaOportunidades.vue'
import FunilOportunidades from '../FunilOportunidades.vue'
import KanbanOportunidades from '../KanbanOportunidades.vue'
import RelatorioOportunidades from '../RelatorioOportunidades.vue'

export default {
  components: {
    TotalizadorFechado,
    ListaOportunidades,
    KanbanOportunidades,
    FunilOportunidades,
    RelatorioOportunidades
  },
  data () {
    return {
      tabs: 0
    }
  },
  methods: {
    loadContent () {}
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.largura_funil {
  margin: 0 auto;
  width: 50vw;
  @media (max-width: 991px){
    width: 100%;
  }
}
.item_funil {
  margin: 0 auto;
  margin-bottom: 30px;
  position: relative;
  text-align: center;
  .fundo_diagonal {
    opacity: 0.7;
    position: absolute;
    width: 55%;
    left: 90px;
    top: 82px;
    height: 50%;
    transform: rotate(17deg);
  }
  .funil_cor {
    align-items: center;
    display: flex;
    justify-content: center;
    height: 90px;
  }
  .status_area {
    align-items: center;
    border: 1px solid;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: 100%;
    left: -340px;
    padding: 5px;
    position: absolute;
    width: 300px;
  }
  &:nth-of-type(even) {
    .fundo_diagonal {
      left: inherit;
      right: 75px;
      transform: rotate(-21deg);
    }
    .status_area {
      left: inherit;
      right: -320px;
    }
  }
  &:nth-last-of-type(1) {
    .fundo_diagonal {
      visibility: hidden;
    }
  }
}
.funil_cor {
  overflow: hidden;
  position: relative;
  &:after {
    border-bottom: 93px solid;
    border-left: 60px solid transparent;
    bottom: 0;
    content: '';
    position: absolute;
    right: -1px;
  }
  &:before {
    border-bottom: 93px solid;
    border-right: 60px solid transparent;
    bottom: 0;
    content: '';
    left: -1px;
    position: absolute;
  }
}
.border-black {
  &:before {
    border-bottom-color: $black;
  }
  &:after {
    border-bottom-color: $black;
  }
}
.border-white {
  &:before {
    border-bottom-color: white;
  }
  &:after {
    border-bottom-color: white;
  }
}
>>>.v-tabs-items {
  min-height: calc(100vh - 200px)!important;
  padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/oportunidades/fechadas/Fechadas.vue